import Link from "@/components/NextJs/Link";

import { DropdownItemProps } from "./DropdownItem";
import { twMerge } from "tailwind-merge";

import Typography from "../../Typography/Typography";
import Icon from '../../Icon/Icon';

import styles from './DropdownItem.module.css';

interface Props extends DropdownItemProps {
    href: string;
    label: string;

}

const DropdownLinkItem = ({ href, className, icon, iconPosition = 'before', label }: Props) => {

    const classNames = twMerge(styles.DropdownItem, className);

    return (
        <Link href={href} className={classNames}>
            {iconPosition === 'before' && icon && <Icon icon={icon} />}
            <Typography variant="meta" className="grow">{label}</Typography>
            {iconPosition === 'after' && icon && <Icon icon={icon} />}
        </Link>
    )

}

export default DropdownLinkItem;
